<template>
  <div class="MyAccount">
    <MobileNav :page_title="nav_title"></MobileNav>

    <div class="sideBarSection">
      <MyAccountSideBar
        v-if="isDesktop"
        @selectedMenu="selectedMenu"
      ></MyAccountSideBar>
    </div>

    <div class="account-container">
      <div class="account-details-section">
        <div
          v-if="!isDesktop"
          class="flex-center flex-wrap top-margin-10 bottom-margin-10  menu-list"
        >
          <div
            v-for="(menu, menu_index) in menu_list"
            :key="menu_index"
            class="flex margin-right-20 cursor-pointer"
          >
            <div
              class="flex"
              @click="selectedMenu(menu.title)"
              style="margin: 5px"
              :style="[
                menu.title == 'Change Password' &&
                userProfile &&
                userProfile.utm_medium != 'EMAIL'
                  ? { display: 'none' }
                  : {},
              ]"
            >
              <img :src="menu.icon" width="18" class="right-margin-10" />
              <div
                style="font-size: 14px; color: #9c9ca0"
                :class="[
                  myAccountActiveState == menu.title
                    ? 'active-mobile-menu'
                    : '',
                ]"
              >
                {{ menu.title }}
              </div>
            </div>
          </div>
          
          <div v-if="hasPublisherPlan" style="margin-bottom:20px">
            <hr style="margin:20px 0px" />
            <el-collapse v-model="activeNames" @change="handleChange">
              <el-collapse-item name="1">
                <template #title>
                  <div class="download-title">
                    <div
                      ref="certificateContainer"
                      style="position: absolute; left: -9999px; width: 100vw;"
                    >
                      <PublisherCertificate
                        ref="certificate"
                        :certificateData="certificateData"
                      />
                    </div>
                    <div
                      :style="{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor:
                          certificateData &&
                          certificateData.is_eligible_for_download
                            ? 'pointer'
                            : 'not-allowed',
                        opacity:
                          certificateData &&
                          certificateData.is_eligible_for_download
                            ? 1
                            : 0.5,
                      }"
                      @click="handleDownloadClick"
                    >
                      <span
                        style="margin-right: 5px; font-size: 18px; font-weight: 600;"
                      >
                        Certificate
                      </span>
                      <span>
                        <img
                          src="../assets/images/Download Icon (1).svg"
                          alt=""
                          style="width: 18px;"
                        />
                      </span>
                    </div>
                  </div>
                </template>
                <div
                  class="font-06rem capitalize font-weight-600 text-center"
                  style="color: #505050; font-size: 10px; background-color: white; padding: 20px 10px; border-radius: 10px;"
                >
                  You can Download your <br />
                  NISM certificate after completion of <br />your 30 Days Track
                  record
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>

        <el-row
          :gutter="10"
          v-if="
            myAccountActiveState == 'Biling and Payments' ||
              myAccountActiveState == 'Membership' ||
              myAccountActiveState == 'Admin Control Panel'
          "
        >
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-row :gutter="15">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <PlanDetails></PlanDetails>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div v-if="myAccountActiveState == 'Biling and Payments'">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <TransactionHistory class="top-margin-10"></TransactionHistory>
            </el-col>
          </el-row>
        </div>

        <div v-if="myAccountActiveState == 'Membership'">
        </div>

        
        <div v-if="myAccountActiveState == 'FAQ'">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <PaymentFaq class="top-margin-10"></PaymentFaq>
            </el-col>
          </el-row>
        </div>

        <div v-if="myAccountActiveState == 'Change Password'">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <ChangePasswordComponent
                class="top-margin-10"
              ></ChangePasswordComponent>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { filterCallBack } from "../mixins/filter";
import { screenSize } from "../mixins/ScreenSize.js";
import MyAccountSideBar from "@/components/MyAccountSideBar.vue";
import PlanDetails from "@/components/PlanDetails.vue";
import TransactionHistory from "@/components/TransactionHistory.vue";
import ConnectedMembers from "@/components/ConnectedMembers.vue";
// import BankDetails from "@/components/BankDetails.vue";
import BillingDetails from "@/components/BillingDetails.vue";
import MyDownloads from "@/components/MyDownloads.vue";
import PaymentFaq from "@/components/PaymentFaq.vue";
import ChangePasswordComponent from "@/components/ChangePasswordComponent.vue";
import MobileNav from "@/components/MobileNav.vue";
import CripNotice from "crip-vue-notice";
import NoDataFound from "@/components/NoDataFound.vue";
import { EventBus } from "../eventBus";
import html2canvas from "html2canvas";
import PublisherCertificate from "../components/PublisherCertificate.vue";
import { serverAddr, serverHostName } from "../networkConfig";

export default {
  name: "MyAccount",

  mixins: [filterCallBack, screenSize],

  components: {
    MyAccountSideBar,
    MobileNav,
    NoDataFound,
    TransactionHistory,
    ConnectedMembers,
    // BankDetails,
    BillingDetails,
    ChangePasswordComponent,
    MyDownloads,
    // Support,
    PaymentFaq,
    PlanDetails,
    PublisherCertificate,
  },

  data() {
    return {
      nav_title: "My Account",
      isCollapsed: false,
      activeNames: ["1"],
      certificateData: null,
      hasPublisherPlan: false,
      menu_list: [
        {
          title: "Membership",
          icon: require("../assets/images/membership.png"),
        },
        // {
        //   title: "Bank Details",
        //   icon: require("../assets/images/myAccount/bank_details.png"),
        // },
        {
          title: "Biling and Payments",
          icon: require("../assets/images/myAccount/payments.png"),
        },
        // {
        //   title: "Support",
        //   icon: require("../assets/images/myAccount/support.png"),
        // },
        // {
        //   title: "FAQ",
        //   icon: require("../assets/images/myAccount/question.png"),
        // },
        // {
        //   title: "Change Password",
        //   icon: require("../assets/images/myAccount/password-recovery.png"),
        // },
      ],
      userProfile: {},
      currentEnvironment: localStorage.getItem("currentEnvironment")
        ? JSON.parse(localStorage.getItem("currentEnvironment"))
        : {},
    };
  },

  mounted() {
    this.userProfile = JSON.parse(localStorage.getItem("profile"));
    // if route has query params then store active state of my account and rendered component accordingly
    if (this.$route.query.link) {
      this.$store.commit("commitMyAccountActiveState", this.$route.query.link);
    } else {
      this.$store.commit("commitMyAccountActiveState", "Membership");
    }

    // if (this.userProfile && this.userProfile.utm_source == "Bigul") {
    //   this.$store.commit("commitMyAccountActiveState", "Support");
    //   this.menu_list = [
    //     {
    //       title: "Support",
    //       icon: require("../assets/images/myAccount/support.png"),
    //     },
    //     {
    //       title: "FAQ",
    //       icon: require("../assets/images/myAccount/question.png"),
    //     },
    //     {
    //       title: "Change Password",
    //       icon: require("../assets/images/myAccount/password-recovery.png"),
    //     },
    //   ];
    // }

    if (
      this.currentEnvironment &&
      this.currentEnvironment.loginModule == "BlinkX"
    ) {
      this.menu_list = this.menu_list.filter((item) => item.title !== "FAQ");
    }
    this.getCertificateData();
  },

  methods: {
    selectedMenu(menu) {
      if (this.$route.query.link) {
        //if current route has query params then on menu select removed it
        this.$router.replace("/my-account");
      }

      this.$store.commit("commitMyAccountActiveState", menu); //store my account page active state

      this.$store.commit("commitSupportPageActiveState", "NEW_TICKET"); //store support page active stage to by default show new ticket component

      // on menu select scroll page to top
      var elmnt = document.getElementsByClassName("MyAccount")[0];
      scrollTo(elmnt, 0, 100);
    },
    getCertificateData() {
      serverAddr
        .get("/stockants_pro/get-transaction-history/")
        .then((response) => {
          const transaction = response.data.data.find(
            (trx) => trx.plan_name === "Publisher"
          );
          if (
            transaction &&
            transaction.publisher_certificate_data.length > 0
          ) {
            const data = transaction.publisher_certificate_data[0];
            this.certificateData = {
              is_eligible_for_download: data.is_eligible_for_download,
            };
            this.hasPublisherPlan = true; 
          } else {
            this.certificateData = null;
            this.hasPublisherPlan = false;
          }
        })
        .catch((error) => {
          console.error("Error fetching transaction data:", error);
          this.certificateData = null; 
          this.hasPublisherPlan = false; 
        });
    },
    handleDownloadClick() {
      if (
        this.certificateData &&
        this.certificateData.is_eligible_for_download
      ) {
        this.downloadCertificate();
      } else {
        console.log("Certificate Download not available for 1st 30 days");
      }
    },

    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },

    downloadCertificate() {
      const certificateElement = this.$refs.certificate.$refs.certificate;
      html2canvas(certificateElement)
        .then((canvas) => {
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = "certificate.png";
          link.click();
        })
        .catch((error) => {
          console.error("Error generating image:", error);
        });
    },
    handleChange(val) {
    },
  },

  computed: {
    //returns stored user profile from local storage
    // userProfile() {
    //   return JSON.parse(localStorage.getItem("profile"));
    // },

    // returns active state of my account section from store
    myAccountActiveState() {
      return this.$store.state.my_account_active_state;
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.MyAccount {
  background-color: $page-background-color;
  padding: 60px 0 0 0;
  min-height: calc(100vh - 60px);
}
.MyAccount .account-container {
  width: calc(100% - 265px);
  margin-left: 265px;
  //min-height: 100vh;
  box-sizing: border-box;
}
.MyAccount .active-mobile-menu {
  color: $secondary-theme-color !important;
  font-weight: 600;
}
.MyAccount .account-details-section {
  padding: 20px 20px 0 20px;
}
.MyAccount .footer-section {
  width: calc(100% - 260px);
  margin-left: 260px;
}

@media screen and (max-width: 1283px) {
  .MyAccount {
    padding: 50px 0 80px 0;
  }
  .MyAccount .account-container,
  .MyAccount .footer-section {
    width: 100%;
    margin-left: 0;
  }
  .MyAccount .account-details-section {
    padding: 20px 10px 0 10px;
  }
  .MyAccount .sideBarSection {
    display: none;
  }
}
@media screen and (max-width: 600px) {
  .MyAccount .menu-list {
    display: block;
  }
}
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.MyAccount .box-card {
  border-radius: 10px !important;
  border: none;
  box-shadow: none;
}
</style>
